import axios from "axios";
import config from "../../../../../config/config";

export const CREATE_FAV_PASSENGER = config.baseUrl + "favoritePassenger";
export const DELETE_FAV_PASSENGER = config.baseUrl + "favoritePassenger/";
export const UPDATE_FAV_PASSENGER = config.baseUrl + "favoritePassenger/";

export const getAllFavPassengers = (user) => {
  return axios.get(config.baseUrl + "ticket/favoritePassenger", {
    headers: { "x-access-token": user.accessToken },
  });
};

export function createFavPassenger(user, data) {
  return axios.post(CREATE_FAV_PASSENGER, data, {
    headers: { "x-access-token": user.accessToken },
  });
}

export function updateFavPassenger(user, JobgroupId, data) {
  return axios.put(UPDATE_FAV_PASSENGER + JobgroupId, data, {
    headers: { "x-access-token": user.accessToken },
  });
}

export function deleteFavPassenger(user, champaignId) {
  return axios.delete(DELETE_FAV_PASSENGER + champaignId, {
    headers: { "x-access-token": user.accessToken },
  });
}
